<div class="hpanel sticky-nav">
  <!-- <div class="col-md-12"> -->
  <div class="panel-body border-radius-top-left-right-6">
    <div class="navIteam">
      <div class="title-wrap">
        <h5 class="fw-bold">  {{selectedMenu?.menu}}
        </h5>
        <small>{{provider.getCount(selectedMenu.widgetName)}} results found</small>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="renderNDC && dynamicComponent && widgetInjector">
  <ng-template
    [ngComponentOutlet]="dynamicComponent"
    [ngComponentOutletInjector]="widgetInjector">
  </ng-template>
</ng-container>
